module.exports = __webpack_public_path__ + "static/greg-laurie.519ca6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/greg-laurie.jpg
// module id = 278
// module chunks = 168707334958949